import React from 'react'
import Shop from '../components/Shop'
export default function ShopPage() {
  return (
   <><Shop></Shop></>
  )
}
